import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue'
import ProfileEventRow from '@/pages/ProfilePage/ui/ProfileEventRow.vue'
import { IEventPeriod } from '@/enitites/event/model/types'
import { useEventsListQuery } from '@/enitites/event/api/queries'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileEventList',
  props: {
    tab: null,
    userId: null,
    withPagination: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  tab: IEventPeriod
  userId: number
  withPagination?: boolean
};



const infiniteObserverRef = ref<HTMLDivElement | null>(null)
const infiniteObserver = ref<IntersectionObserver | null>(null)

const searchParams = computed(() => ({
  pageNumber: 0,
  pageSize: props.withPagination ? 20 : 100,
  userId: props.userId,
  tab: props.tab,
}))

const { data, isLoading, hasNextPage, fetchNextPage, isFetchingNextPage } = useEventsListQuery(searchParams)

const events = computed(() => {
  return data.value?.pages.flatMap((page) => page) ?? []
})

watch(
  () => infiniteObserverRef.value,
  () => {
    if (props.withPagination && infiniteObserverRef.value) {
      infiniteObserver.value = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && hasNextPage.value && !isLoading.value && !isFetchingNextPage.value) {
              fetchNextPage()
            }
          })
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 1.0,
        }
      )
      infiniteObserver.value.observe(infiniteObserverRef.value)
    }
  }
)

return { __sfc: true,props, infiniteObserverRef, infiniteObserver, searchParams, data, isLoading, hasNextPage, fetchNextPage, isFetchingNextPage, events, ProfileEventRow }
}

})